import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import style from './comingSoon.module.css'
import NavBar from '../../components/common/NavBar'

const ComingSoonPage = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [isSubmitted, setIsSubmitted] = useState(false)

  // Animation countdown (optionnel)
  const [countdown, setCountdown] = useState({
    days: 30,
    hours: 12,
    minutes: 45,
    seconds: 30
  })

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 }
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 }
        } else if (prev.hours > 0) {
          return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 }
        } else if (prev.days > 0) {
          return { ...prev, days: prev.days - 1, hours: 23, minutes: 59, seconds: 59 }
        }
        return prev
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log('Email soumis:', email)
    setIsSubmitted(true)
    setTimeout(() => {
      setIsSubmitted(false)
      setEmail('')
    }, 3000)
  }

  return (
    <div className={style.mainComingSoon}>
      <NavBar navBarInfo={{
        navLogo: 'Get-Conseil',
        links: ['Home', 'Blog', 'Contact', 'About', 'Services']
      }} />

      <div className={style.comingSoonContainer}>
        <div className={style.backgroundAnimation}>
          <div className={style.circle1}></div>
          <div className={style.circle2}></div>
          <div className={style.circle3}></div>
        </div>

        <div className={style.content}>
          {/* Main Icon */}
          <div className={style.iconContainer}>
            <div className={style.mainIcon}>🚀</div>
          </div>

          {/* Main Message */}
          <h1 className={style.mainTitle}>Bientôt Disponible</h1>
          <p className={style.subtitle}>
            Cette page est en cours de préparation
          </p>

          <div className={style.messageBox}>
            <p className={style.message}>
              Nous travaillons activement pour vous offrir une expérience exceptionnelle.
              Cette section sera bientôt accessible avec du contenu de qualité et des 
              services adaptés à vos besoins.
            </p>
          </div>

          {/* Countdown Timer */}
          <div className={style.countdownSection}>
            <h3>Lancement Estimé</h3>
            <div className={style.countdown}>
              <div className={style.countdownItem}>
                <span className={style.countdownNumber}>{countdown.days}</span>
                <span className={style.countdownLabel}>Jours</span>
              </div>
              <div className={style.countdownSeparator}>:</div>
              <div className={style.countdownItem}>
                <span className={style.countdownNumber}>{countdown.hours}</span>
                <span className={style.countdownLabel}>Heures</span>
              </div>
              <div className={style.countdownSeparator}>:</div>
              <div className={style.countdownItem}>
                <span className={style.countdownNumber}>{countdown.minutes}</span>
                <span className={style.countdownLabel}>Minutes</span>
              </div>
              <div className={style.countdownSeparator}>:</div>
              <div className={style.countdownItem}>
                <span className={style.countdownNumber}>{countdown.seconds}</span>
                <span className={style.countdownLabel}>Secondes</span>
              </div>
            </div>
          </div>

          {/* Features Coming */}
          <div className={style.featuresSection}>
            <h3>Ce qui vous attend</h3>
            <div className={style.featuresGrid}>
              <div className={style.featureCard}>
                <span className={style.featureIcon}>📄</span>
                <p>Articles détaillés</p>
              </div>
              <div className={style.featureCard}>
                <span className={style.featureIcon}>💼</span>
                <p>Services innovants</p>
              </div>
              <div className={style.featureCard}>
                <span className={style.featureIcon}>🎯</span>
                <p>Solutions sur mesure</p>
              </div>
              <div className={style.featureCard}>
                <span className={style.featureIcon}>🤝</span>
                <p>Accompagnement personnalisé</p>
              </div>
            </div>
          </div>

          {/* Newsletter Signup */}
          <div className={style.notifySection}>
            <h3>Soyez informé du lancement</h3>
            <p>Inscrivez-vous pour recevoir une notification dès que cette page sera disponible</p>
            
            {!isSubmitted ? (
              <form onSubmit={handleSubmit} className={style.notifyForm}>
                <input
                  type="email"
                  placeholder="Votre adresse email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className={style.emailInput}
                />
                <button type="submit" className={style.notifyBtn}>
                  M'informer
                </button>
              </form>
            ) : (
              <div className={style.successMessage}>
                <span className={style.successIcon}>✓</span>
                <p>Merci ! Nous vous tiendrons informé.</p>
              </div>
            )}
          </div>

          {/* Navigation Buttons */}
          <div className={style.navigationSection}>
            <p>En attendant, découvrez nos autres services</p>
            <div className={style.navButtons}>
              <button 
                className={style.navBtn}
                onClick={() => navigate('/')}
              >
                Retour à l'accueil
              </button>
              <button 
                className={style.navBtn}
                onClick={() => navigate('/services')}
              >
                Nos services
              </button>
              <button 
                className={style.navBtn}
                onClick={() => navigate('/contact')}
              >
                Nous contacter
              </button>
            </div>
          </div>

          {/* Social Links */}
          <div className={style.socialSection}>
            <p>Suivez-nous pour rester connecté</p>
            <div className={style.socialLinks}>
              <a href="#" className={style.socialLink}>in</a>
              <a href="#" className={style.socialLink}>f</a>
              <a href="#" className={style.socialLink}>𝕏</a>
              <a href="#" className={style.socialLink}>📷</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ComingSoonPage